module.exports = "<div class=\"login\">\n    <s-login-form :on-submit=\"onSubmit\" class=\"d-flex flex-column w-75\" />\n</div>\n"